export enum UserType {
  unknown = 0,
  internal = 1,
  external = 2,
}
